const artBadgeTags: string[] = [
  'Aalto-yliopisto',
  'Aalto University',
  'Finnkino',
  'Sun Effects',
  'FlowxOpera',
  'FlowxOoppera',
  'Pink Space'
];

export function getArtTagBadges(tags: {name: string}[]): {name: string}[] {
  return tags.filter((tag: {name: string}) => {
    return artBadgeTags.includes(tag.name);
  });
}


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/arts/artUtils.ts